import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class SpannerILReaderView extends View {
    setup() {
        this.label = "Spanner";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.SPANNER.id);
        this.model.set("isCDC", false);
        this.model.set("hasAutoSchemaConversion", window.location.href.indexOf("-to-create-schema") !== -1);
    }
}
module.View = SpannerILReaderView;
module.vent = new Backbone.Model();
export default module;